import React, { useState } from 'react';
import { handlePhoneInput } from '../../utils/phoneFormat';

const CreateAccount = ({ gymData, onComplete }) => {
  const [formData, setFormData] = useState({
    name: gymData.managerName || '',
    email: gymData.managerEmail || '',
    password: '',
    confirmPassword: '',
    phone: ''
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Apply phone formatting if it's the phone field
    const finalValue = name === 'phone' ? handlePhoneInput(value) : value;

    setFormData(prev => ({
      ...prev,
      [name]: finalValue
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      onComplete({
        password: formData.password,
        phone: formData.phone || null,
        managerName: formData.name || null
      });
    }
  };

  return (
    <div className="bg-white rounded-xl p-6 sm:p-8 border-2 border-slate-900 shadow-retro">
      <div className="flex items-center gap-2 mb-6">
        <span className="w-1 h-8 bg-gradient-to-b from-teal-500 to-purple-500 rounded"></span>
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">Create Your Account</h2>
      </div>

      <p className="text-slate-700 mb-6">
        Welcome to BoardRez! Let's set up your manager account for <span className="font-bold">{gymData.gym.name}</span>.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            Your Name
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-slate-900 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-teal-500"
            placeholder="Your full name"
          />
        </div>

        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            Email
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            disabled
            className="w-full px-4 py-3 border-2 border-slate-300 rounded-lg font-medium bg-slate-50 text-slate-600"
          />
          <p className="text-xs text-slate-600 mt-1 flex items-center gap-1">
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            This is the verified email for your gym
          </p>
        </div>

        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            Create Password *
          </label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            className={`w-full px-4 py-3 border-2 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-teal-500 ${
              errors.password ? 'border-coral-500' : 'border-slate-900'
            }`}
            placeholder="At least 8 characters"
          />
          {errors.password && (
            <p className="text-sm text-coral-600 mt-1 font-medium">{errors.password}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            Confirm Password *
          </label>
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            className={`w-full px-4 py-3 border-2 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-teal-500 ${
              errors.confirmPassword ? 'border-coral-500' : 'border-slate-900'
            }`}
            placeholder="Re-enter your password"
          />
          {errors.confirmPassword && (
            <p className="text-sm text-coral-600 mt-1 font-medium">{errors.confirmPassword}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            Phone Number (Optional)
          </label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-4 py-3 border-2 border-slate-900 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-teal-500"
            placeholder="(303) 555-1234"
          />
          <p className="text-xs text-slate-600 mt-1">For support and important notifications</p>
        </div>

        <button
          type="submit"
          className="w-full px-6 py-4 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-lg border-2 border-slate-900 shadow-retro hover:shadow-retro-hover transition-all touch-manipulation"
        >
          Create Account →
        </button>
      </form>
    </div>
  );
};

export default CreateAccount;
